import { Button, PlatformMessage } from '@thg-commerce/gravity-elements'
import {
  margin,
  mq,
  spacing,
  styled,
  Text,
  TextEntry,
  TextStyle,
} from '@thg-commerce/gravity-theme'

export const StyledPlatformMessage = styled(PlatformMessage)`
  margin-bottom: ${spacing(3)};
`

export const AddToBasketContainer = styled.div<{
  enableQuantity: Boolean
  hasPaddingBottom?: boolean
  flexDirection?: 'row' | 'column'
}>`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding-bottom: ${(props) => (!props.hasPaddingBottom ? spacing(1) : 0)};

  ${(props) => !props.enableQuantity && `margin-top: ${spacing(2)}`}
  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    flex-direction: ${(props) => props.flexDirection || 'row'};
  }
`

export const QuantityPlatformMessage = styled(PlatformMessage)`
  margin-bottom: ${spacing(2)};
`

export const QuantitySelectorContainer = styled.div<{
  margin: {
    top: string
    right: string
    bottom: string
    left: string
  }
}>`
  ${(props) => margin(props.margin)}
`

export const StyledButtonContainer = styled.div<{ isFullWidth?: boolean }>`
  display: flex;
  ${(props) => props.isFullWidth && 'flex: 1'};
  align-items: center;
  height: max-content;
  margin-bottom: ${spacing(2)};
`

export const StyledButton = styled(Button)`
  width: 100%;
  white-space: nowrap;
  height: 48px;
`

export const QuantityText = styled.p<{
  quantityTextLabelStyle?: {
    textStyle: {
      entry: TextEntry
      style: TextStyle
    }
  }
}>`
  ${(props) =>
    Text(
      props?.quantityTextLabelStyle?.textStyle?.entry || 'bodyText',
      props?.quantityTextLabelStyle?.textStyle?.style || 'alternate',
    )}
  margin-bottom: ${spacing(1)};
`
export const WishlistButtonWrapper = styled.div<{ hasBorderOutline?: boolean }>`
  ${(props) =>
    props.hasBorderOutline &&
    `display: flex; 
     justify-content: center;
     width: 100%;
     padding: ${spacing(1.25)}; 
     border-radius: ${props.theme.button.high.regular.default.borderRadius};
     border: 1px solid ${props.theme.colors.palette.brand.base};
     `}
`
